<script>
  import { createEventDispatcher } from 'svelte';

  export let title;
  export let href;
  export let description;
  export let launchLabel;
  export let icon = '✉';

  const dispatch = createEventDispatcher();
  // A route owns its color: reopening, reordering or reusing the card cannot change it.
  $: hue = Array.from(href).reduce((hash, character) => (hash * 31 + character.charCodeAt(0)) >>> 0, 0) % 360;
</script>

<section class="card widget" aria-label={title} style={`--accent: hsl(${hue}, 65%, 42%); --tint: hsl(${hue}, 80%, 96%);`}>
  <div class="widget-header">
    <h3 class="widget-title"><span class="icon" aria-hidden="true">{icon}</span>{title}</h3>
    <div class="widget-actions">
      <a class="button small dashboard-launch" {href} target="_blank" rel="noopener noreferrer">Open full page ↗</a>
      <button type="button" class="button small" on:click={() => dispatch('close')}>Close</button>
    </div>
  </div>
  <div class="launcher-body">
    <p>{description}</p>
    <a class="dashboard-launch large" {href} target="_blank" rel="noopener noreferrer">{launchLabel} ↗</a>
  </div>
</section>

<style>
  .card { box-sizing: border-box; margin: 0; padding: 15px; display: flex; flex-direction: column; gap: 10px; border-radius: 8px; color: #000; background: var(--tint); border-left: 6px solid var(--accent); box-shadow: 0 0 1px #28293d14, 0 .5px 2px #60617029; }
  .widget-header, .widget-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .widget-header { justify-content: space-between; }
  .widget-title { display: inline-flex; align-items: center; gap: 10px; margin: 0; padding: 6px 8px; font-size: 14px; font-weight: 800; color: #1f2937; }
  .icon { width: 18px; display: inline-flex; justify-content: center; font-size: 14px; }
  .button, .dashboard-launch { display: inline-flex; align-items: center; justify-content: center; box-sizing: border-box; margin: 0; font: inherit; border-radius: 6px; white-space: nowrap; cursor: pointer; text-decoration: none; }
  .button { background: #fff; border: 1px solid #ccc; color: #000; }
  .small { min-height: 36px; padding: 6px 10px; font-size: 12px; }
  .dashboard-launch { background: #0c131d; border: 1px solid #1b8d68; color: #dce7f3; font-weight: 700; }
  .large { min-height: 44px; padding: 10px 14px; }
  .launcher-body { display: flex; align-items: center; justify-content: space-between; gap: 18px; padding: 12px 8px 4px; }
  p { margin: 0; line-height: 1.5; color: #475569; }
  a:focus-visible, button:focus-visible { outline: 2px solid #14695b; outline-offset: 3px; }
  @media (max-width: 600px) { .launcher-body { align-items: stretch; flex-direction: column; } .large { white-space: normal; text-align: center; } }
</style>
